// External modules
import { Form } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';

// Internal modules

import styles from '../styles/SignUpForm.module.scss';

function SignUpForm({ props }) {
  const {
    errors,
    handleBlur,
    handleChange,
    handleSubmit,
    isOpen,
    isValid,
    onChangeSignUpFormOpenFunc,
    status,
    setFieldTouched,
    touched,
    values: { emailAddress, password, providerId, secret, type },
  } = props;
  function onChange(name, e) {
    e.persist();
    handleChange(e);
    setFieldTouched(name, true, false);
  }

  function onPressEnter(event) {
    if (event.key === 'Enter') {
      handleSubmit();
    }
  }

  function renderMessageStatus(status) {
    if (!status) return;
    const { message, errorMessage } = status;

    let msg = message;
    if (errorMessage) msg = errorMessage;

    if (message) return <div className={styles.message}>{msg}</div>;
    if (errorMessage) return <div className={styles.errorMessage}>{msg}</div>;
  }

  return (
    <Dialog className={styles.root} open={isOpen} onClose={() => onChangeSignUpFormOpenFunc(false)}>
      <DialogTitle className={styles.title}>Sign Up</DialogTitle>
      <DialogContentText className={styles.subHeading}>
        Password:
        <br />* At least 8 characters in length
      </DialogContentText>
      <DialogContent>
        <Form id="login-form">
          {renderMessageStatus(status)}
          <div className={styles.textField}>
            <TextField
              autoComplete="off"
              className={styles.textField}
              error={touched.emailAddress && Boolean(errors.emailAddress)}
              id="emailAddress"
              label="Email Address"
              helperText={touched.emailAddress ? errors.emailAddress : ''}
              onChange={onChange.bind(null, 'emailAddress')}
              onKeyDown={onPressEnter}
              value={emailAddress}
            />
          </div>
          <div className={styles.textField}>
            <TextField
              autoComplete="off"
              className={styles.textField}
              error={touched.password && Boolean(errors.password)}
              id="password"
              label="Password"
              helperText={touched.password ? errors.password : ''}
              onChange={onChange.bind(null, 'password')}
              onKeyDown={onPressEnter}
              type="password"
              value={password}
            />
          </div>
          <div className={styles.textField}>
            <FormControl fullWidth>
              <InputLabel>Type</InputLabel>
              <Select name="type" value={type} onChange={handleChange} onBlur={handleBlur}>
                <MenuItem value={'customer'}>Customer</MenuItem>
                <MenuItem value={'concierge'}>Concierge</MenuItem>
                <MenuItem value={'provider'}>Provider</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div className={styles.textField}>
            <TextField
              autoComplete="off"
              className={styles.textField}
              error={touched.providerId && Boolean(errors.providerId)}
              id="providerId"
              label="Provider Id"
              helperText={touched.providerId ? errors.providerId : ''}
              onChange={onChange.bind(null, 'providerId')}
              onKeyDown={onPressEnter}
              value={providerId}
            />
          </div>
          <div className={styles.textField}>
            <TextField
              className={styles.textField}
              error={touched.secret && Boolean(errors.secret)}
              id="secret"
              label="AmazingCo Secret Key"
              helperText={touched.secret ? errors.secret : ''}
              onChange={onChange.bind(null, 'secret')}
              onKeyDown={onPressEnter}
              type="password"
              value={secret}
            />
          </div>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onChangeSignUpFormOpenFunc(false)} color="primary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} disabled={!isValid} color="primary">
          Sign Up
        </Button>
      </DialogActions>
    </Dialog>
  );
}

SignUpForm.propTypes = {
  props: PropTypes.object.isRequired,
};
SignUpForm.defaultProps = {};

export default SignUpForm